import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Logo from "../../Utils/Logo";

const Header = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  let profileName = localStorage.getItem("current_user");
  profileName = !!profileName
    ? profileName
        .split(" ")
        .map((n) => n[0])
        .join("")
    : "";
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const location = useLocation();

  const toggleNavbar = () => setCollapsed(!collapsed);
  return (
    <Navbar
      color="transparant"
      className="navbar-absolute w-100 light"
      light
      expand="lg"
    >
      <div className="container">
        <NavbarBrand href="/">
          <Logo />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} />
        <Collapse isOpen={!collapsed} navbar>
          {!props.noLinks && (
            <React.Fragment>
              <Nav navbar className="ml-auto">
                <NavItem active={window.location.pathname === "/"}>
                  <NavLink href="/">HOME</NavLink>
                </NavItem>
                <NavItem active={window.location.pathname === "/about-us"}>
                  <NavLink href="/about-us">ABOUT</NavLink>
                </NavItem>
                <NavItem active={window.location.pathname === "/rules"}>
                  <NavLink href="/rules">RULES</NavLink>
                </NavItem>
                <NavItem active={window.location.pathname === "/hall-of-fame"}>
                  <NavLink href="/hall-of-fame">HALL OF FAME</NavLink>
                </NavItem>
                <NavItem active={window.location.pathname === "/prizes"}>
                  <NavLink href="/prizes">PRIZES</NavLink>
                </NavItem>
                <NavItem active={window.location.pathname === "/editions"}>
                  <NavLink href="/editions"> EDITIONS </NavLink>
                </NavItem>
              </Nav>
              {!!profileName && (
                <a
                  href="/pre-start"
                  className="btn btn-yellow ml-lg-3 btn-resumeplay-width"
                >
                  RESUME PLAYING
                </a>
              )}
              {!!!profileName && (
                <React.Fragment>
                  <a
                    href="/login"
                    className="btn btn-yellow ml-lg-3 btn-login-width"
                  >
                    Login
                  </a>
                  <a
                    href="/register"
                    className="btn btn-yellow ml-md-3 btn-login-width"
                  >
                    Register
                  </a>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
